<template>
	<div class="header2">
		<div class="box2 cf">
	        <a :href="protocolUrl+'//'+hostnameUrl" class="logo fl dpb">
	        	<img :src="logoUrl">
	        </a>
    	</div>
    </div>
</template>
<script>
import { getHeader ,getBaseInfo} from "@/api/person/person";
export default {
	name: 'headers',
	data(){
		return{
			logoUrl:'',
			hostnameUrl:window.location.hostname,
			protocolUrl:window.location.protocol	
		}
	},
	mounted(){
		let that=this;
		that.getHeadInfoFun()
	},
	activated(){
		
	},
	computed:{
		
	},
	methods: {
		getHeadInfoFun(){
	      let that=this
	      getBaseInfo({}).then(res => {
	        //console.log(res)
	        if(res.success) {
	        	let siteAdList=res.result.siteAdList
	        	that.logoUrl=res.result.logo 
	        	siteAdList.forEach((item,index)=>{
	        		if (that.hostnameUrl==item.domain) {
	        			that.logoUrl=item.image
	        		}
	        	})
	        }
	      });
	    },
   	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/headers/index.vue